<!-- 图片广告 -->
<template>
    <div
        v-if="componentsData.type == 5"
        :style="`padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;`"
    >
        <imgStyle
            v-if="hasPicview"
            class="img-style"
            :imageData="componentsData"
            :imgList="[]"
        ></imgStyle>
        <div v-else class="none-div">请上传图片</div>
    </div>
</template>

<script>
import imgStyle from "@/components/imgStyle/imgStyle.vue";
export default {
    components: {
        imgStyle,
    },
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        bg_color: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {};
    },
    computed: {
        hasPicview() {
            const imgList = this.componentsData.content.imgList;
            // 检查imgList存在并且是非空数组，且至少有一个元素有picview属性值
            if (!imgList || !imgList.length) {
                return false;
            }
            return imgList.some(
                (item) => item.picview != null && item.picview !== ""
            );
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.img-style {
    height: 100%;
}
.none-div {
    font-size: 14px;
    height: 260px;
    border: 1px dashed #ccc;
    background-color: #fff;
}
</style>